const picc = {
  getAttachCondition(state, data) { // 该函数的被 writeStore.js 引用
    let currClauseCode = data.curr.clauseCode
    let attachCondition, currGroupProductPremium
    let insureHouseArea = state.insureHouseArea
    for (let clause in state.clausePremium) {
      if (state.clausePremium[clause]) {
        for (let item of state.clausePremium[clause]) { // 责任
          if (item.clauseCode === currClauseCode) {
            currGroupProductPremium = item.groupProductPremiumList.find(gpp => gpp.insured === data.curr.selected.insured)
            for (let perm of currGroupProductPremium.premiumList) {
              let currAttachCondition = JSON.parse(perm.attachCondition)
              if (JSON.parse(data.curr.attachPremium).attachPremiumKey) {
                if (currAttachCondition.insureHouseArea == insureHouseArea) {
                  attachCondition = currAttachCondition
                }
              } else {
                attachCondition = currAttachCondition
              }
            }
          }
        }
      }
    }
    return attachCondition
  },
  getPrice(state, plan, sameInsured, price) { // 该函数的被 orderFun.js 引用
    let area = state.insureHouseArea // 1：小于500，501:大于500
    let attachPremium = JSON.parse(plan.attachPremium).attachPremiumKey
    sameInsured.premiumList.forEach(si => {
      let attachCondition = JSON.parse(si.attachCondition)
      if (attachCondition[attachPremium] == area) {
        price += si.premium
        // 附加险是否加 50
        let currURBP023 = state.schemes[0].planList.find(item => item.clauseCode === 'URBP023')
        console.log('currURBP023', currURBP023)
        if (currURBP023 && currURBP023.selected.insured > 0) {
          price += 50
        }
      }
    })
    return price
  },

}

export default picc


// WEBPACK FOOTER //
// ./src/util/pulicInsuranceOfPICC.js